export default "__VITE_ASSET__BrDG8ZSC__"